import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import ListUi from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {
  styles,
  SecondaryText,
} from '../Sidebar.styles';

const List = ({
  data,
  classes,
  onItemClick,
}) => {
  return (
    <ListUi disablePadding>
      {data.map(item => (
        <ListItem
          key={item.name}
          className={classes.listItem}
          onClick={() => onItemClick(item)}
          button
        >
          <ListItemText disableTypography>
            {item.name}
          </ListItemText>
          <SecondaryText>{item.textSecondary}</SecondaryText>
        </ListItem>
      ))}
    </ListUi>
  );
};

export default withStyles(styles)(List);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Sidebar/List/List.js